﻿import swal, { type SweetAlertResult } from 'sweetalert2';

const swalBase = swal.mixin({
    didOpen: (popup) => {
        if (popup.parentElement) {
            popup.parentElement.style.zIndex = '200000';
        }
    }
});

function deletePopup(
    afterConfirmFunc?: () => void,
    afterCancelFunc?: () => void,
    confirmText?: string
) {
    if (!confirmText) {
        confirmText = 'Вы уверены, что Вы хотите удалить запись? Это действие необратимо! Продолжить?';
    }

    swalBase.fire({
        title: 'Вы уверены?',
        text: confirmText,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Удалить!',
        cancelButtonText: 'Отмена',
        focusCancel: true
    })
        .then((result: SweetAlertResult) => {
            result.value ? afterConfirmFunc?.() : afterCancelFunc?.();
        });
}

function standartErrorAnswer() {
    swalBase.fire(
        'Внимание!',
        'Не был получен ответ от сервера. Возможно, изменения не сохранились. Попробуйте еще раз.',
        'warning'
    );
}

window.swal = swalBase;
window.standartErrorAnswer = standartErrorAnswer;
window.deletePopup = deletePopup;
